////////LIBRARY/////////
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isUndefined } from 'lodash'
/////////ASSETS/////////
import SortDescActiveIcon from '../../../assets/icones/toggleFilters/toggle-desc-active.svg'
import SortDescDesactiveIcon from '../../../assets/icones/toggleFilters/toggle-desc-desactive.svg'
import SortAscActiveIcon from '../../../assets/icones/toggleFilters/toggle-asc-active.svg'
import SortAscDesactiveIcon from '../../../assets/icones/toggleFilters/toggle-asc-desactive.svg'

/////////STYLED/////////
const ToggleFiltersWrapper = styled.div`
	display: flex;
	align-items: center;
	filter: ${(props) => (props.disabled ? 'grayscale(1)' : 'grayscale(0)')};
`
const Slider = styled.span`
	position: absolute;
	cursor: ${(props) => (props.isNotAllowed ? 'not-allowed' : 'pointer')};
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: ${(props) => props.theme.colors.white};
	border: 1px solid ${(props) => props.theme.colors.primary};
	-webkit-transition: 0.4s;
	transition: 0.4s;
	border-radius: 13px;
	::before {
		position: absolute;
		content: '';
		height: ${(props) => (props.size === 'large' ? '15px' : '11px')};
		width: ${(props) => (props.size === 'large' ? '15px' : '11px')};
		left: ${(props) => (props.size === 'large' ? '3px' : '2px')};
		top: ${(props) => (props.size === 'large' ? '3px' : '2px')};
		background-color: ${(props) => props.theme.colors.primary};
		-webkit-transition: 0.4s;
		transition: 0.4s;
		border-radius: 13px;
		transform: translateX(0);
	}
`
const SwitchToggle = styled.label`
	position: relative;
	display: inline-block;
	width: ${(props) => (props.size === 'large' ? '43px' : '32px')};
	height: ${(props) => (props.size === 'large' ? '23px' : '17px')};
`
const InputSwitchToggle = styled.input`
	opacity: 0;
	width: 0;
	height: 0;
	margin: 0px;
	border: 1px solid transparent;

	:focus + ${Slider} {
		box-shadow: 0 0 1px ${(props) => props.theme.colors.primary};
	}

	:checked + ${Slider}:before {
		transform: ${(props) => (props.size === 'large' ? 'translateX(20px)' : 'translateX(15px)')};
	}
`
const ToggleLabelPrev = styled.label`
	margin: 0px 5px;
	color: ${(props) => (!props.isChecked ? props.theme.colors.primary : props.theme.colors.eraser)};
	font-weight: bold;
	font-size: ${(props) => props.theme.font.fs};
	display: inherit;
`
const ToggleLabelNext = styled.label`
	margin: 0px 5px;
	color: ${(props) => (props.isChecked ? props.theme.colors.primary : props.theme.colors.eraser)};
	font-weight: bold;
	font-size: ${(props) => props.theme.font.fs};
	display: inherit;
`
const ToggleLabelPrevIcon = styled.img`
	margin: 0px 5px;
`
const ToggleLabelNextIcon = styled.img`
	margin: 0px 5px;
`
/////////STYLED/////////

/**
 *
 * @param checked
 * @param onChangeHandler
 * @param id
 * @returns {*}
 */
const ToggleFilters = ({
	checked,
	onChangeHandler,
	name,
	labelPrev,
	labelNext,
	sortPics,
	reverseCheck = false,
	size = 'normal',
	prevActiveIcon,
	prevDesactiveIcon,
	nextActiveIcon,
	nextDesactiveIcon,
	disabled = false,
}) => {
	if (reverseCheck) checked = !checked

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ToggleFiltersWrapper disabled={disabled}>
			<ToggleLabelPrev isChecked={checked}>
				{sortPics ? (
					<ToggleLabelPrevIcon isChecked={checked} src={!checked ? SortDescActiveIcon : SortDescDesactiveIcon} />
				) : !isUndefined(prevActiveIcon) ? (
					<ToggleLabelPrevIcon isChecked={checked} src={!checked ? prevActiveIcon : prevDesactiveIcon} />
				) : (
					labelPrev
				)}
			</ToggleLabelPrev>
			<SwitchToggle size={size}>
				<InputSwitchToggle
					checked={checked}
					type={'checkbox'}
					onChange={() => !disabled && onChangeHandler()}
					name={name}
					size={size}
					disabled={disabled}
				/>
				<Slider size={size} isNotAllowed={disabled} />
			</SwitchToggle>
			<ToggleLabelNext isChecked={checked}>
				{sortPics ? (
					<ToggleLabelNextIcon isChecked={checked} src={checked ? SortAscActiveIcon : SortAscDesactiveIcon} />
				) : !isUndefined(nextActiveIcon) ? (
					<ToggleLabelPrevIcon isChecked={checked} src={checked ? nextActiveIcon : nextDesactiveIcon} />
				) : (
					labelNext
				)}
			</ToggleLabelNext>
		</ToggleFiltersWrapper>
	)
}

ToggleFilters.propTypes = {
	checked: PropTypes.bool,
	onChangeHandler: PropTypes.func,
	id: PropTypes.number,
}

export default ToggleFilters
